// src/components/homepage/AgentPod.tsx
import React from 'react';
import { Mic, Send } from 'lucide-react';

interface AgentPodProps {
  agentData: {
    greeting_p1: string;
    greeting_p2: string;
    greeting_p3: string;
    placeholder: string;
  };
}

export const AgentPod: React.FC<AgentPodProps> = ({ agentData }) => {
  return (
    <div className="bg-white/60 backdrop-blur-md rounded-3xl border-2 border-black h-full flex flex-col p-4 shadow-[8px_8px_0_0_rgb(17,24,39)] transform transition-all duration-300 hover:shadow-[10px_10px_0_0_rgb(17,24,39)] hover:-translate-x-0.5 hover:-translate-y-0.5">
      {/* 3D Agent Avatar Placeholder */}
      <div className="flex-grow bg-slate-200 rounded-xl flex items-center justify-center mb-4 border-2 border-black p-4">
        <p className="text-slate-500 font-medium text-center">
          [Interactive 3D Agent Avatar Loads Here]
        </p>
      </div>

      {/* Greeting Text */}
      <div className="bg-white rounded-xl p-4 border-2 border-black text-sm text-slate-700 space-y-2 mb-4">
        <p>{agentData.greeting_p1}</p>
        <p>{agentData.greeting_p2}</p>
        <p className="font-semibold text-slate-800">{agentData.greeting_p3}</p>
      </div>

      {/* Input Field Mockup */}
      <div className="relative mt-auto">
        <input
          type="text"
          placeholder={agentData.placeholder}
          className="w-full bg-white rounded-xl py-3.5 pl-4 pr-24 border-2 border-black focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none placeholder-slate-400"
          disabled // Kept disabled as it's a mockup
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-2.5">
          <button
            className="p-2 text-slate-400 hover:text-emerald-600 transition-colors disabled:text-slate-300"
            aria-label="Use microphone"
            disabled
          >
            <Mic size={22} />
          </button>
          <button
            className="p-2 text-slate-400 hover:text-emerald-600 transition-colors disabled:text-slate-300"
            aria-label="Send message"
            disabled
          >
            <Send size={22} />
          </button>
        </div>
      </div>
    </div>
  );
};

